module.exports = "/images/add-icon.svg?738b628c7cc263ff6580a1acd5de50bc";